import React from "react";

function DownIcon() {
  return (
    <span className="anticon anticon-down">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 14 8"
      >
        <path
          fill="none"
          fillRule="evenodd"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M1 1l6 6 6-6"
        ></path>
      </svg>
    </span>
  );
}

export default DownIcon;
